export const homeScreen: any[] = [
  // { element: '#chatHeader', popover: { title: 'Chat', description: 'You can tap here to start chatting with other people using CMED.', side: "right", align: 'start' }},
  {
    element: "#settingsHeader",
    popover: {
      title: "User Settings",
      description:
        "View clearing accounts, manage push notifications, and access tools.",
      side: "right",
      align: "start",
    },
  },
  {
    element: "#IonFabButton",
    popover: {
      title: "Additional Options  ",
      description:
        "View options by clicking on the 3 dots icon on the bottom right.",
      side: "right",
      align: "start",
    },
  },
  {
    element: "#AddContracts",
    popover: {
      title: "Add a contract",
      description:
        " Click here to add a new contract to the current grid group",
      side: "right",
      align: "start",
    },
  },
  {
    element: "#TurnOnLiveAndOff",
    popover: {
      title: "Live View",
      description:
        "Click here to enable live view - it let’s you view all contracts which have an existing order. ",
      side: "right",
      align: "start",
    },
  },
  {
    element: "#EditGrids",
    popover: {
      title: "Edit",
      description: " Click here to edit the grid groups",
      side: "right",
      align: "start",
    },
  },
  {
    element: "#tab-button-Market",
    popover: {
      title: "Market",
      description: "Head in to setup your Market Data feed and place orders.",
      side: "right",
      align: "start",
    },
  },
  {
    element: "#tab-button-OptionsGrid",
    popover: {
      title: "Options",
      description:
        "Select an underlying future and start viewing market data and placing orders.",
      side: "top",
      align: "end",
    },
  },
  {
    element: "#tab-button-Orders",
    popover: {
      title: "Orders",
      description: "List of all your orders with options to filter them.",
      side: "right",
      align: "start",
    },
  },
  // { element: '#tab-button-RFQFeed', popover: { title: 'RFQ Feed', description: 'Live feed of all RFQ\'s', side: "right", align: 'end' }},  // Temporarily removing RFQ Feed popup from app tour
  // {
  //   element: "#tab-button-BlockFeed",
  //   popover: {
  //     title: "Block",
  //     description: "Live feed of all block trades.",
  //     side: "right",
  //     align: "end",
  //   },
  // },
  // {
  //   element: "#tab-button-QuikStrike",
  //   popover: {
  //     title: "QuickStrike",
  //     description:
  //       "Head in here to use our charting tool to spot patterns and see real time information.",
  //     side: "top",
  //     align: "start",
  //   },
  // },
  {
    element: "#tab-button-Positions",
    popover: {
      title: "Positions",
      description:
        "Position view offers enhanced exchange position data on a per-Contract level.",
      side: "top",
      align: "start",
    },
  },
  {
    element: "#tab-button-More",
    popover: {
      title: "More",
      description:
        "Head in here to view insights, charting tool and Live feed of all the block trades.",
      side: "top",
      align: "start",
    },
  },
];

export const orderBook: any[] = [
  {
    element: "#orderSearch",
    popover: {
      title: "Search Order",
      description: "Search by side, contract, price...",
      side: "right",
      align: "start",
    },
  },
  {
    element: "#filterOrder",
    popover: {
      title: "Filter",
      description: "Tap here to apply filters!",
      side: "bottom",
      align: "left",
    },
  },
  {
    element: "#savedOrder",
    popover: {
      title: "Saved Filters",
      description: "You can save them too.",
      side: "top",
      align: "start",
    },
  },
  {
    element: "#hold-all-orders",
    popover: {
      title: "Hold All Orders",
      description: "Hold all your current working orders with a single tap.",
      side: "top",
      align: "start",
    },
  },
  {
    element: "#kill-all-orders",
    popover: {
      title: "Kill All Orders",
      description:
        "A global kill switch. Kill all working orders with a single tap.",
      side: "top",
      align: "start",
    },
  },
];

export const chatScreen: any[] = [
  {
    element: "#tab-button-Chat",
    popover: {
      title: "Direct Message",
      description:
        "One to one messaging. Chat with other traders using CME Direct.",
      side: "left",
      align: "start",
    },
  },
  {
    element: "#tab-button-Blast",
    popover: {
      title: "Blast",
      description:
        "Blast (broadcast) messages to multiple traders with a single tap!",
      side: "left",
      align: "start",
    },
  },
  {
    element: "#tab-button-Groups",
    popover: {
      title: "Groups",
      description: "Create groups which can be used for blast messaging.",
      side: "left",
      align: "start",
    },
  },
  {
    element: "#tab-button-Settings",
    popover: {
      title: "Chat Settings",
      description:
        "Manage alerts based on specific keywords, and create quick chat shortcuts.",
      side: "left",
      align: "start",
    },
  },
  {
    element: "#txtMessageSearch",
    popover: {
      title: "Search",
      description:
        "Search for other users and send them a request. You can also search for messages in your chat over the last 90 days.",
      side: "left",
      align: "start",
    },
  },
  {
    element: "#addUser",
    popover: {
      title: "User Requests",
      description:
        "View all the chat requests from other users here. You can chose to accept or deny them.",
      side: "left",
      align: "start",
    },
  },
  {
    element: "#checkStatus",
    popover: {
      title: "Current Status",
      description:
        "Set you current status. You can choose from Available, Busy, Offline and Away.",
      side: "left",
      align: "start",
    },
  },
];

export const blockFeed: any[] = [
  {
    element: "#blockFeedFilter",
    popover: {
      title: "Filter",
      description:
        "Apply filters by asset class and get customized real time feeds!",
      side: "left",
      align: "start",
    },
  },
];

export const rfqFeed: any[] = [
  {
    element: "#rfqFeedFilter",
    popover: {
      title: "Filter",
      description:
        "Apply filters by asset class and get customized real time feeds!",
      side: "left",
      align: "start",
    },
  },
];

export const optionsGrid: any[] = [
  {
    element: "#IonsegmentButton",
    popover: {
      title: "Add",
      description:
        "You can swipe here to see the different grids you've added. By scrolling to the end and clicking on the + icon you can add more grids to your screen.",
    },
  },
  {
    element: "#underlyingFuture",
    popover: {
      title: "Underlying Future",
      description: "Select the underlying future of the option.",
      side: "left",
      align: "start",
    },
  },
  {
    element: "#expiry",
    popover: {
      title: "Expiry",
      description: "The type of expiry - Weekly, Monthly, etc",
      side: "left",
      align: "start",
    },
  },
  {
    element: "#greeks",
    popover: {
      title: "Greeks",
      description: "You can choose to view greeks in the grid.",
      side: "left",
      align: "start",
    },
  },
  {
    element: "#searchOptions",
    popover: {
      title: "Search",
      description:
        "Once you're all done, tap search and select the product you want!",
      side: "left",
      align: "start",
    },
  },
];

export const blast: any[] = [
  {
    element: "#groupSelection",
    popover: {
      title: "Select by Group",
      description: "",
      side: "left",
      align: "start",
    },
  },
  {
    element: "#contactSelection",
    popover: {
      title: "Select by Contact",
      description: "",
      side: "left",
      align: "start",
    },
  },
  {
    element: "#blastHistory",
    popover: {
      title: "Blast History",
      description: "",
      side: "top",
      align: "start",
    },
  },
  {
    element: "#quillTextEditor",
    popover: {
      title: "Rich Text Editor",
      description: "",
      side: "left",
      align: "start",
    },
  },
  {
    element: "#addMarketMessage",
    popover: {
      title: "Add Market Message",
      description: "",
      side: "top",
      align: "start",
    },
  },
  {
    element: "#sendMessage",
    popover: {
      title: "Send Message",
      description: "",
      side: "top",
      align: "end",
    },
  },
];

export const groups: any[] = [
  {
    element: "#createGroup",
    popover: {
      title: "Create Group",
      description: "",
      side: "left",
      align: "start",
    },
  },
  {
    element: "#allGroups",
    popover: {
      title: "All Groups",
      description: "",
      side: "left",
      align: "start",
    },
  },
];

export const chatSettings: any[] = [
  {
    element: "#keywordAlerts",
    popover: {
      title: "Keyword Alerts",
      description:
        "Create alerts based on keywords - e.g. when someone sends a message with the work sell - you could make the alert red!",
      side: "top",
      align: "start",
    },
  },
  {
    element: "#quickChat",
    popover: {
      title: "Quick Chat Buttons",
      description:
        "Create shortcuts for phrases which you user frequently - omw - on my way! ",
      side: "top",
      align: "start",
    },
  },
];
